import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from './components/AdminLayout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Analytics from './pages/Analytics';
import PostAnalytics from './pages/PostAnalytics';
import BlogManager from './pages/BlogManager';
import BlogEditor from './pages/BlogEditor';
import ApiKeys from './pages/ApiKeys';
import Settings from './pages/Settings';
import MediaLibrary from './pages/MediaLibrary';
import AbuseReports from './pages/AbuseReports';
import InboxManager from './pages/InboxManager';
import InboxDetail from './pages/InboxDetail';
import OwnMail from './pages/OwnMail';
import Redirects from './pages/Redirects';
import AdminUsers from './pages/AdminUsers';
import { AdminPollingProvider } from './context/AdminPollingContext';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AdminPollingProvider>
              <AdminLayout />
            </AdminPollingProvider>
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="blog" element={<BlogManager />} />
        <Route path="blog/new" element={<BlogEditor />} />
        <Route path="blog/edit/:id" element={<BlogEditor />} />
        <Route path="blog/analytics/:id" element={<PostAnalytics />} />
        <Route path="api-keys" element={<ApiKeys />} />
        <Route path="settings" element={<Settings />} />
        <Route path="media" element={<MediaLibrary />} />
        <Route path="abuse-reports" element={<AbuseReports />} />
        <Route path="inboxes" element={<InboxManager />} />
        <Route path="inboxes/:address" element={<InboxDetail />} />
        <Route path="own-mail" element={<OwnMail />} />
        <Route path="admin-users" element={<AdminUsers />} />
        <Route path="redirects" element={<Redirects />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
